<div class="files-list">
  <div class="single-file row" [ngClass]="{'clickable-item': !onError}">
    <div class="file-icon col-sm-2">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 58 58"
        style="enable-background:new 0 0 58 58;" xml:space="preserve">
        <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
        <g>
          <path style="fill:#CEC9AE;"
            d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
          <path style="fill:#CEC9AE;"
            d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
          <path style="fill:#CEC9AE;"
            d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
          <path style="fill:#CEC9AE;"
            d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
          <path style="fill:#CEC9AE;"
            d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
        </g>
        <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
      </svg>
    </div>
    <div class="info col-xs-8 col-sm-9 col-md-8">
      <div class="title" #eRef>
        <input [readOnly]="true" [disabled]="true" [ngClass]="{'edit-name-off': !editMode, 'edit-name-on': editMode}"
          (change)="onEditItemName($event)" [(ngModel)]="!!file.nomeFile ? file.nomeFile : file.title" type="text">
      </div>
      <app-progress-bar [onError]="onError" (click)="onHandleItemClick(file)" [progress]="progress"></app-progress-bar>
      <span *ngIf="onError" class="error-msg text-danger">Non è stato possibile caricare il documento</span>
    </div>
    <div class="container-icon col-xs-2 col-sm-2 col-md-1 col-lg-1">
      <div class="row">
        <div class="col-xs-6 col-sm-6 col-md-6">
          <div class="edit" *ngIf="!onError">
            <i class="glyphicon glyphicon-send" (click)="onHandleItemClick(file)"></i>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6">
          <div class="delete" (click)="onHandleDeleteItemClick(file)">
            <!-- <div class="delete-doc-icon"></div> -->
            <i class="glyphicon glyphicon-trash"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>